import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { ApplicationApiService } from '../data-services/index';
import { IProgramCycle } from '@ebb-v2/ebb-integration';

export interface IProgramCycleList {
    id: string;
    programCycles: IProgramCycle[];
  }

@Injectable({
    providedIn: 'root'
  })
export class ProgramCycleResolver implements Resolve<any> {

  constructor(
      private http: HttpClient,
      private applicationApiService: ApplicationApiService
      ) { }

  resolve(): Observable<any> {
    return this.applicationApiService
    .getProgramCycles()
    .pipe(map(
      response => response
     ),
     take(1),
     catchError(err => of(err)));
  }
}
